import React from "react";
import * as Ph from "@phosphor-icons/react";
import { Reveal, SectionHeading, Starburst } from "../common";
import { TRUST_CARDS } from "../../data/site";

const Trust = () => (
  <section className="py-24 md:py-32 bg-background" data-testid="trust-section">
    <div className="max-w-[88rem] mx-auto px-5 md:px-10">
      <Reveal>
        <SectionHeading
          overline="Why Clients Choose Jet"
          title="Cleaning built on trust, not luck."
        />
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-3 gap-6">
        {TRUST_CARDS.map((c, i) => {
          const Icon = Ph[c.icon] || Ph.Sparkle;
          return (
            <Reveal key={c.title} delay={i * 0.1}>
              <div
                className="group h-full rounded-3xl border border-border bg-card p-8 md:p-10 transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(0,180,216,0.35)]"
                data-testid={`trust-card-${i}`}
              >
                <div className="grid place-items-center h-16 w-16 rounded-2xl bg-jet-teal/10 text-jet-teal mb-7 transition-colors group-hover:bg-jet-teal group-hover:text-white">
                  <Icon size={34} weight="duotone" />
                </div>
                <h3 className="font-display text-2xl font-semibold text-jet-ink mb-3">
                  {c.title}
                </h3>
                <p className="text-jet-ink/65 leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-6 relative overflow-hidden rounded-3xl bg-gradient-to-br from-jet-teal to-jet-teal-deep text-white px-8 py-12 md:px-14 md:py-16">
          <Starburst className="absolute -right-8 -top-8 h-48 w-48 text-white/10" />
          <div className="relative max-w-2xl">
            <p className="text-white/70 text-sm font-bold uppercase tracking-[0.2em] mb-3">
              Owner-operated & personally accountable
            </p>
            <p className="text-white font-display text-2xl md:text-4xl font-semibold leading-tight">
              You work directly with us — no call centers, no runaround, just a
              thorough clean you can count on.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Trust;
